var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.5,49c15.3,35.4,24.1,81.3,25,130h86.6c-3.7-86-63.7-157.7-144-179.1C337.4,10.6,348.7,26.2,358.5,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.9,179.1c0.9-48.7,9.7-94.6,25-130c9.9-22.8,21.1-38.4,32.3-49C146,21.4,86,93.1,82.3,179.1H168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.4,255h28.8v75.8c33.9-31,56.7-73.8,62-121.8h-86.1C382.4,224.9,380.8,240.3,378.4,255L378.4,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.8,209.1H83.3c1.8,16,5.5,31.4,10.9,46h33.6L127.8,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,255H348c2.5-14.5,4.3-29.9,5.1-46h-61.9V255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.6,179.1c-1.9-95-35.8-170.6-77.3-170.6c-41.5,0-75.4,75.6-77.3,170.6L353.6,179.1L353.6,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.8,209.1h103.5v46H157.8V209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,429h335.4v83H41.8L41.8,429z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,399h75.3v-36.6h30V399h124.8v-36.6h30V399h75.3V285H41.8L41.8,399z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/International.d93b842d3db077bd63fc102993c1b081.svg";
export { ForwardRef as ReactComponent };